import { render, staticRenderFns } from "./BallDisplay.vue?vue&type=template&id=0a56dd7a&scoped=true"
import script from "./BallDisplay.vue?vue&type=script&lang=js"
export * from "./BallDisplay.vue?vue&type=script&lang=js"
import style0 from "./BallDisplay.vue?vue&type=style&index=0&id=0a56dd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56dd7a",
  null
  
)

export default component.exports